/* src/app/modules_v2/finance/loan/components/loan-operation-dialog/loan-operation-dialog.component.scss */
.lo-header-text {
  min-width: 0;
  padding-right: 32px;
}
.lo-body {
  padding: 0 !important;
}
.lo-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 24px;
  background:
    linear-gradient(
      135deg,
      #fbfee8 0%,
      #f4fbd0 100%);
  border-bottom: 1px solid #e5f3a0;
}
.lo-summary__left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.lo-summary__icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(227, 253, 100, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.lo-summary__icon-wrap mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: #1a1d23;
}
.lo-summary__label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #6b7280;
}
.lo-summary__amount {
  display: block;
  font-size: 22px;
  font-weight: 700;
  color: #1a1d23;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
}
.lo-summary__hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-variant-numeric: tabular-nums;
}
.lo-summary__after {
  text-align: right;
}
.lo-summary__after-amount {
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
}
.lo-summary__after-amount--negative {
  color: #dc2626;
}
.lo-section {
  padding: 18px 24px 6px;
  border-bottom: 1px solid #f0f0f0;
}
.lo-section:last-child {
  border-bottom: none;
  padding-bottom: 18px;
}
.lo-section .cf-dlg-section__label {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.lo-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 12px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  color: #6b7280;
  cursor: pointer;
}
.lo-link:hover {
  color: #1a1d23;
  text-decoration: underline;
}
.lo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 0 16px;
}
.lo-grid__wide {
  grid-column: span 2;
}
.lo-suffix {
  font-size: 14px;
  color: #6b7280;
  margin-right: 6px;
}
.lo-empty {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 13px;
  color: #4b5563;
}
.lo-empty mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  color: #6b7280;
}
.lo-empty--error mat-icon {
  color: #dc2626;
}
.lo-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.lo-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
}
.lo-item--editing {
  border-color: #c5d94a;
  background: #fbfee8;
}
.lo-item__main {
  flex: 1;
  min-width: 0;
}
.lo-item__amount {
  font-size: 15px;
  font-weight: 700;
  color: #1a1d23;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.lo-item__meta {
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lo-item__date {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  flex-shrink: 0;
}
.lo-item__actions {
  display: flex;
  gap: 2px;
  flex-shrink: 0;
}
.lo-item__btn {
  width: 32px;
  height: 32px;
  padding: 4px;
  color: #6b7280 !important;
}
.lo-item__btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.lo-item__btn--danger:hover {
  color: #dc2626 !important;
}
@media (max-width: 600px) {
  .lo-summary {
    flex-direction: column;
    align-items: flex-start;
  }
  .lo-summary__after {
    text-align: left;
  }
  .lo-grid__wide {
    grid-column: auto;
  }
  .lo-item {
    flex-wrap: wrap;
  }
}
/*# sourceMappingURL=loan-operation-dialog.component.css.map */
